<template>
  <div
    class="o-taskgroupitem"
    :class="[
      `state-${state.type}`,
      renderGroup ? 'group-visible' : 'group-hidden'
    ]"
  >
    <div
      class="taskgroupitem__task"
      :class="[
        hasExternalLink || deeplink !== undefined || isInsurance || hasKatalogLink || hasFileuploadLink
          ? 'group-clickable'
          : ''
      ]"
      @click="triggerDeeplink"
    >
      <div class="task__attention">
        <font-awesome-icon class="attention__icon" icon="exclamation-circle" />
      </div>
      <div class="task__items">
        <div class="items__content content--icon" :class="{ centered: done }">
          <button
            class="section-toggler"
            v-b-toggle="taskGroup._id"
            @click="stopPropagation"
          >
            <div class="img toggler-icon__collapse"></div>
            <div class="img toggler-icon__expand"></div>
          </button>
        </div>
        <div class="items__content content--icon2">
          <svg v-if="taskGroup.serviceGroup == 'VERZ'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1500 1500">
            <path class="cls-1" d="M977.19,268.46v-77.41h-85.36c-.42-77.84-63.88-141.05-141.83-141.05s-141.41,63.21-141.83,141.05h-85.35v77.41H243.17v1181.54h1013.66V268.46h-279.64ZM561.32,229.55h85.35v-37.72c0-56.97,46.34-103.32,103.32-103.32s103.32,46.35,103.32,103.32v37.72h85.36v115.96h-377.36v-115.96ZM1218.32,1411.49H281.68V306.97h241.14v77.05h454.37v-77.05h241.14v1104.53Z"/>
            <path class="cls-1" d="M750,128.71c-34.19,0-62,27.81-62,62s27.81,62,62,62,61.99-27.81,61.99-62-27.81-62-61.99-62ZM750,214.2c-12.95,0-23.5-10.54-23.5-23.5s10.54-23.49,23.5-23.49,23.48,10.54,23.48,23.49-10.53,23.5-23.48,23.5Z"/>
            <rect class="cls-1" x="335" y="458" width="142" height="107"/>
            <rect class="cls-1" x="518" y="458" width="640" height="107"/>
            <rect class="cls-1" x="518" y="649" width="640" height="107"/>
            <rect class="cls-1" x="335" y="649" width="142" height="107"/>
            <rect class="cls-1" x="335" y="840" width="142" height="107"/>
            <rect class="cls-1" x="518" y="840" width="640" height="107"/>
            <rect class="cls-1" x="335" y="1031" width="142" height="107"/>
            <rect class="cls-1" x="518" y="1031" width="640" height="107"/>
            <rect class="cls-1" x="335" y="1222" width="142" height="107"/>
            <rect class="cls-1" x="518" y="1222" width="640" height="107"/>
          </svg>
          <svg v-else-if="taskGroup.serviceGroup == 'LLC'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1500 1500">
            <path class="cls-1" d="M977.19,268.46v-77.41h-85.36c-.42-77.84-63.88-141.05-141.83-141.05s-141.41,63.21-141.83,141.05h-85.35v77.41H243.17v1181.54h1013.66V268.46h-279.64ZM561.32,229.55h85.35v-37.72c0-56.97,46.34-103.32,103.32-103.32s103.32,46.35,103.32,103.32v37.72h85.36v115.96h-377.36v-115.96ZM1218.32,1411.49H281.68V306.97h241.14v77.05h454.37v-77.05h241.14v1104.53Z"/>
            <path class="cls-1" d="M750,128.71c-34.19,0-62,27.81-62,62s27.81,62,62,62,61.99-27.81,61.99-62-27.81-62-61.99-62ZM750,214.2c-12.95,0-23.5-10.54-23.5-23.5s10.54-23.49,23.5-23.49,23.48,10.54,23.48,23.49-10.53,23.5-23.48,23.5Z"/>
            <rect class="cls-1" x="335" y="458" width="142" height="107"/>
            <rect class="cls-1" x="518" y="458" width="640" height="107"/>
            <rect class="cls-1" x="518" y="649" width="640" height="107"/>
            <rect class="cls-1" x="335" y="649" width="142" height="107"/>
            <rect class="cls-1" x="335" y="840" width="142" height="107"/>
            <rect class="cls-1" x="518" y="840" width="640" height="107"/>
            <rect class="cls-1" x="335" y="1031" width="142" height="107"/>
            <rect class="cls-1" x="518" y="1031" width="640" height="107"/>
            <rect class="cls-1" x="335" y="1222" width="142" height="107"/>
            <rect class="cls-1" x="518" y="1222" width="640" height="107"/>
          </svg>
          <svg v-else-if="taskGroup.serviceGroup == 'PARKPL'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1500 1500">
            <g>
              <path class="cls-1" d="M1208.68,222.07l40.17,230.84c2.49,14.29-8.51,27.37-23.02,27.37H247.19c-12.9,0-23.36,10.46-23.36,23.36v624.67c0,11.35-8.15,21.05-19.33,23.01h0c-12.72,2.23-24.84-6.28-27.06-19.01L54.01,423.14c-2.21-12.71,6.3-24.81,19.01-27.02l1108.64-193.06c12.71-2.21,24.81,6.3,27.03,19.01Z"/>
              <rect class="cls-1" x="1052.41" y="983.79" width="255.34" height="149.28" rx="14.95" ry="14.95"/>
            </g>
            <path class="cls-1" d="M754.57,952.63h-263.19c-14.73,0-26.67-11.94-26.67-26.67v-263.19c0-14.73,11.94-26.67,26.67-26.67h263.19c14.73,0,26.67,11.94,26.67,26.67v263.19c0,14.73-11.94,26.67-26.67,26.67ZM511.99,905.35h221.97v-221.97h-221.97v221.97Z"/>
            <path class="cls-1" d="M552.7,726.8h85.13c23.74,0,41.12,8.88,49.62,23.74,3.86,6.57,5.78,14.29,5.78,22.97s-1.93,16.61-5.78,23.17c-8.5,14.67-25.87,23.74-49.62,23.74h-29.92v41.51h-55.21v-135.14ZM624.51,784.33c5.6,0,9.65-1.93,11.78-5.79.77-1.35,1.34-3.09,1.34-5.02s-.57-3.66-1.34-5.01c-2.13-3.67-6.18-5.6-11.78-5.6h-16.6v21.43h16.6Z"/>
            <g>
              <rect class="cls-1" x="331.02" y="725.05" width="133.97" height="137.91"/>
              <rect class="cls-1" x="780" y="725.05" width="617.51" height="137.91"/>
            </g>
            <path class="cls-1" d="M1365.13,534.3H300.37c-12.43,0-22.51,10.08-22.51,22.51v721.62c0,12.43,10.08,22.51,22.51,22.51h1127.12c12.43,0,22.51-10.08,22.51-22.51v-721.62c0-12.43-10.08-22.51-22.51-22.51h-62.36ZM1375,1251.72H353.53c-12.43,0-22.51-10.08-22.51-22.51v-623.5c0-12.43,10.08-22.51,22.51-22.51h1021.47c12.43,0,22.51,10.08,22.51,22.51v623.5c0,12.43-10.08,22.51-22.51,22.51Z"/>
          </svg>
          <svg v-else-if="taskGroup.serviceGroup === 'DILE' || taskGroup.serviceGroup === 'DIENST2'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1500 1500">
            <path class="cls-1" d="M1398.92,1258.46c-.43-35.07-13.16-64.74-37.87-88.18-5.96-5.65-12.51-10.6-19.34-15.19,4.19-42.66-5.48-77.08-28.98-102.25-50.33-53.9-158-56.62-256.8-52.21-50.63,2.28-113.03,2.64-174.7,2.07,16.85-17.33,26.12-38.91,27.85-59.81,3.7-44.47-24.51-97.72-95.17-109.54-7.01-1.2-14.07,1.89-18.09,7.75-1.52,2.19-38.11,54.06-126.93,62.84-20.88,2.06-45.87-2.58-74.86-7.96-79.24-14.7-186.37-34.49-295.3,79.53-14.33-14.62-39.24-30.86-77.89-27.16-71.64,6.94-119.78,99.76-119.78,230.94s72.26,251.4,148.67,251.4c24.74,0,47.73-13.07,67.47-37.66,52.62,44.82,119.19,56.95,186.44,56.95,41.17,0,82.58-4.49,121.12-8.66,14.17-1.54,28.1-3.05,41.65-4.31,186.48-17.32,355.36-9.09,456.26-4.19,82.55,4.06,106.92,4.84,119.61-2.71,17.83-10.61,39.08-33.17,39.08-80.32,0-2.3-.09-4.86-.26-7.56,2.49.07,5.05.13,7.46.21,8.23.24,16.21.48,23.87.48,26.91,0,49.97-2.98,66.32-19.04,14.13-13.87,20.54-34.68,20.16-65.45ZM1224.54,1398.25c-10.15,2.52-53.87.43-100.08-1.82-101.89-4.96-272.41-13.24-461.4,4.3-13.74,1.28-27.87,2.81-42.21,4.37-128.52,13.87-261.32,28.3-328.66-102.92-.24-.44-24.78-44.57-32.44-78.02l-4.07-17.77-35.54,8.15,4.07,17.77c8.84,38.59,35.06,85.7,35.86,87.1,9.35,18.22,19.91,33.86,31.34,47.54-13.2,17.64-27.71,27.31-41.67,27.31-44.15,0-112.22-92.31-112.22-214.95s45.01-190.6,86.83-194.66c26.24-2.58,42.09,9.3,50.24,18.33-20.93,26.03-34.81,50.06-42.21,73.14l-5.57,17.36,34.72,11.14,5.57-17.36c6.61-20.63,20.9-43.9,42.32-69.15,1.41-1.2,2.58-2.51,3.55-4.03,99.73-114.5,192.51-97.46,274.42-82.24,30.39,5.65,59.1,10.97,85.1,8.4,82.8-8.2,128.41-49.37,145.58-68.75,40.7,10.75,56.93,41.24,54.68,68.4-2.51,30.2-29.02,60.54-82.29,61.39-95.04-2.07-171.15-5.33-172.59-5.4l-18.21-.78-1.58,36.41,18.2.8c1.35.06,67.62,2.89,153.8,4.96v.62h18.23c1.13,0,2.17-.11,3.29-.13,87.07,1.88,189.65,2.75,265.98-.68,85.13-3.86,188.08-2.68,228.51,40.66,13.62,14.58,20.18,33.96,20.14,58.73-57.09-22.92-123.3-22.88-147.12-21.88-89.37,3.56-349.43.87-412.21.15-4.43-15.8-10.29-29.91-17.69-40.75l-10.27-15.05-30.12,20.55,10.28,15.07c25.01,36.63,28.57,130.91,6.47,171l-8.8,15.96,31.93,17.6,8.8-15.96c3.56-6.45,6.6-13.79,9.15-21.79,40.17-1.05,299.92-7.43,385.96.07,43.94,3.84,95.01,18.43,108.69,63.46.16,2.33.68,4.54,1.64,6.55,1.2,5.71,1.99,11.75,1.99,18.39,0,23.92-6.66,39.77-20.36,48.43ZM1353.22,1297.91c-9.91,9.75-33.58,9-63.56,8.12-5.39-.17-11-.32-16.74-.43-13.78-34.55-49.09-72.8-137.17-80.48-84.22-7.34-320.71-1.96-381.41-.43,2.95-23.55,2.83-49.17-.21-73.41,74.14.82,319.52,3.19,406.42-.27,59-2.36,136.11,8.42,175.42,45.71,17.53,16.65,26.2,36.98,26.5,62.19.24,19.61-2.88,32.74-9.24,39.01Z"/>
            <path class="cls-1" d="M348.63,1139.75l-16.06,8.54,17.06,32.16,16.09-8.5c1.38-.73,138.96-71.73,265.73,1.17l15.81,9.09,18.17-31.61-15.81-9.09c-144.61-83.07-294.65-5.13-300.99-1.75Z"/>
            <path class="cls-1" d="M788.85,525.08c47.09,0,85.27-42.27,85.27-94.41s-38.18-94.41-85.27-94.41-85.27,42.27-85.27,94.41,38.18,94.41,85.27,94.41ZM751.68,373.36l.63-.55.63.55s23.73,19.93,23.73,56.47-24.36,55.86-24.36,55.86c0,0-24.36-19.31-24.36-55.86s23.73-56.47,23.73-56.47Z"/>
            <path class="cls-1" d="M502.58,533.42c.84,2.35,1.59,4.29,2.41,6.22l-95.35,80.3,133.5,151.6h75.6v38.66h268.95l-4.66-35.65,78.77-3.22,133.31-151.38-95.48-80.42c2.52-6.22,4.82-12.56,6.91-18.97l98.22,19.65,14.52,2.95v-.05l-.28-226.1v-9l-66.46,2.1-48.28,22.77c-1.45-4.12-2.97-8.21-4.6-12.24l95.45-80.39-133.5-151.6h-78.97l5.05-38.65h-270.62l5.05,38.65h-78.98l-133.51,151.6,95.5,80.41c-.81,1.99-1.56,4.02-2.33,6.04l-37.07-6.25-85.01-.17v219.62h83.01l38.85-6.48ZM475.74,346.49l110.91,18.69,2.98-10.26c3.26-11.21,7.31-22.26,12.01-32.84l3.66-8.25-90.39-76.12,103.26-117.25,66.41,101.68,9.82-5.62c9.15-5.23,18.74-9.72,28.54-13.37l8.95-3.33-16.44-125.79h144.91l-16.43,125.75,8.92,3.35c9.76,3.67,19.35,8.19,28.51,13.45l9.83,5.64,66.45-101.75,103.26,117.25-90.34,76.08,3.65,8.24c4.67,10.56,8.69,21.62,11.94,32.88l.42,1.45,2.83,13.15,7.6-1.64.02.11,97.92-21.17v166.53l-105.68-21.5-1.9,9.31-1.2,4.13c-3.27,11.24-7.31,22.29-12.01,32.84l-3.67,8.25,90.41,76.13-103.26,117.26-66.41-101.69-9.82,5.62c-9.14,5.22-18.73,9.72-28.53,13.38l-8.95,3.33,16.43,125.79h-144.91l16.43-125.75-8.92-3.35c-9.74-3.66-19.33-8.18-28.51-13.44l-9.83-5.64-66.45,101.74-103.27-117.26,90.34-76.09-3.65-8.24c-4.67-10.56-8.7-21.62-11.94-32.87l-2.97-10.29-110.93,18.69v-167.21Z"/>
          </svg>
          <svg v-else-if="taskGroup.serviceGroup === 'VERS'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1500 1500">
            <path class="cls-1" d="M1290.55,207.7C969.32,305.01,772.92,60.46,764.73,50l-29.47.02c-2.02,2.56-203.92,255.2-525.81,157.68l-24.12,17.9v675.6c0,452.61,556.07,547.87,561.68,548.79h5.99c5.61-.92,561.68-96.18,561.68-548.79V225.6l-24.12-17.9ZM1277.27,901.21c0,404.06-484.32,503.36-527.27,511.33-42.95-7.98-527.27-107.27-527.27-511.33V250.26c281.98,72.64,474.34-103.86,527.27-160.47,52.92,56.61,245.25,233.1,527.27,160.47v650.95Z"/>
            <path class="cls-1" d="M620.55,1005.72h244v-244h-244v244ZM760.55,797.72h68v68h-68v-68ZM760.55,901.72h68v68h-68v-68ZM656.55,797.72h68v68h-68v-68ZM656.55,901.72h68v68h-68v-68Z"/>
            <path class="cls-1" d="M796,395l-47.71.51-.24-.24-.24.24h-.33s.16.17.16.17l-408.66,408.2h131.48v282.84h.58v18h554.95v.28h34v-296.76h101.02l-.16-.16,47.14-.09-412-413ZM1005.92,772.24l-.24-.24h-15.69v35.56l.04.04v261.13h-483.58v-236.72h-.46v-64h-6v-.11h-74.04l322.08-321.71,326.07,326.07h-68.18Z"/>
          </svg>
          <svg v-else-if="taskGroup.serviceGroup === 'WERB'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1500 1500">
            <path class="cls-1" d="M910.74,282.64c-60.89,0-112.13,146.35-127.27,345.24,62.55,7.76,110.93,60.45,110.93,124.3s-48.21,116.35-110.6,124.25c15.55,196.69,66.49,340.93,126.94,340.93,72.8,0,131.82-209.24,131.82-467.36s-59.02-467.36-131.82-467.36Z"/>
            <path class="cls-1" d="M741.88,759.8s-4.36-173.22,54.47-383.47c-173.15,172.29-352.84,217.2-420.46,228.45-14.5,2.41-29.18,3.6-43.88,3.6h-133.78c-10.16,0-20.3,1.1-30.2,3.35-125.89,28.6-117.92,148.08-117.92,148.08,0,0-7.97,119.48,117.92,148.08,9.91,2.25,20.04,3.35,30.2,3.35h44.92c-5.19,32.54-8.46,63.47-9.29,88.47-1.44,43.49,3.96,69.49,17.5,84.3,10.86,11.87,29.96,21.24,133.7,21.24,36.52,0,83.54-1.16,144.36-3.78,33.44-1.44,64.28-19.07,82.49-47.15,8.69-13.4,15.68-26.69,21.01-39.8,52.6,32.05,108.35,73.95,163.44,128.77-58.83-210.26-54.47-383.47-54.47-383.47ZM94.02,764.18l.03.53-.03.54c0,.09-.66,11.27,2.43,26.5l-16.01,3.25c-3.19-15.72-2.88-27.62-2.75-30.29-.15-3.29-.6-20.58,5.6-41.83l15.69,4.57c-5.9,20.22-4.96,36.56-4.95,36.73ZM185,650.47c-17.73,4.03-33.19,10.64-45.97,19.66-6.52,4.6-12.45,9.91-17.62,15.78l-12.26-10.81c6.02-6.82,12.9-12.98,20.45-18.32,14.53-10.26,31.95-17.74,51.77-22.25,8.67-1.97,17.67-2.97,26.74-2.97h87.89v16.34h-87.89c-7.85,0-15.63.86-23.12,2.56ZM566.2,1024.67c-8.63,13.32-23.26,21.68-39.13,22.36-29.75,1.28-85.13,3.67-136.32,3.81-66.8.18-91.21-3.6-99.63-5.73-3.08-10.63-6.26-43.59,4.02-113.67,1.02-6.94,2.09-13.68,3.19-20.21h33.67c14.7,0,29.38,1.18,43.88,3.6,39.42,6.56,116.93,24.57,209.01,72.57-4.17,11.97-10.45,24.55-18.7,37.27Z"/>
            <path class="cls-1" d="M1433.66,733.66h-239.67c-9.02,0-16.34,7.32-16.34,16.34s7.32,16.34,16.34,16.34h239.67c9.02,0,16.34-7.32,16.34-16.34s-7.32-16.34-16.34-16.34Z"/>
            <path class="cls-1" d="M1167.57,639.97c2.77,0,5.58-.71,8.16-2.19l207.56-119.84c7.82-4.51,10.49-14.51,5.98-22.32-4.51-7.82-14.51-10.49-22.32-5.98l-207.56,119.84c-7.82,4.51-10.49,14.51-5.98,22.32,3.03,5.24,8.52,8.17,14.17,8.17Z"/>
            <path class="cls-1" d="M1383.29,982.06l-207.56-119.84c-7.82-4.51-17.81-1.84-22.32,5.98-4.51,7.82-1.84,17.81,5.98,22.32l207.56,119.84c2.57,1.49,5.38,2.19,8.16,2.19,5.65,0,11.14-2.93,14.17-8.17,4.51-7.82,1.84-17.81-5.98-22.32Z"/>
          </svg>
          <svg v-else-if="taskGroup.serviceGroup === 'KSTLOS' || taskGroup.serviceGroup === 'GEBAEUDE' || taskGroup.serviceGroup === 'PFERD'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1500 1500">
            <path class="cls-1" d="M1407.85,1255.83c-.43-35.56-13.34-65.63-38.39-89.39-6.04-5.73-12.69-10.75-19.6-15.4,4.25-43.24-5.56-78.15-29.38-103.66-51.02-54.64-160.17-57.4-260.33-52.92-51.32,2.31-114.58,2.68-177.11,2.1,17.08-17.57,26.48-39.45,28.24-60.64,3.75-45.09-24.85-99.06-96.48-111.05-7.1-1.21-14.26,1.92-18.33,7.85-1.54,2.22-38.63,54.8-128.67,63.71-21.16,2.09-46.5-2.61-75.89-8.07-80.33-14.9-188.93-34.97-299.37,80.63-14.53-14.82-39.78-31.29-78.96-27.53-72.63,7.03-121.43,101.13-121.43,234.12s73.25,254.86,150.72,254.86c25.08,0,48.39-13.25,68.4-38.17,53.34,45.44,120.83,57.74,189,57.74,41.74,0,83.72-4.55,122.78-8.78,14.36-1.56,28.48-3.09,42.23-4.37,189.05-17.55,360.25-9.21,462.53-4.24,83.69,4.11,108.39,4.91,121.25-2.74,18.07-10.76,39.61-33.62,39.61-81.42,0-2.34-.09-4.93-.26-7.66,2.53.07,5.12.14,7.56.21,8.34.25,16.43.49,24.2.49,27.29,0,50.66-3.02,67.23-19.3,14.32-14.06,20.82-35.15,20.44-66.35ZM1231.07,1397.54c-10.29,2.56-54.61.43-101.46-1.85-103.29-5.02-276.16-13.43-467.75,4.36-13.93,1.3-28.25,2.84-42.79,4.43-130.29,14.06-264.91,28.69-333.18-104.33-.25-.45-25.12-45.19-32.89-79.1l-4.13-18.02-36.03,8.26,4.13,18.02c8.97,39.12,35.54,86.88,36.35,88.29,9.48,18.47,20.18,34.32,31.77,48.19-13.38,17.89-28.09,27.69-42.24,27.69-44.75,0-113.76-93.58-113.76-217.91s45.63-193.22,88.02-197.33c26.6-2.61,42.67,9.43,50.93,18.58-21.22,26.38-35.29,50.75-42.79,74.15l-5.64,17.6,35.2,11.29,5.64-17.6c6.71-20.91,21.19-44.5,42.9-70.1,1.43-1.21,2.62-2.54,3.6-4.09,101.11-116.08,195.15-98.8,278.19-83.38,30.81,5.73,59.91,11.12,86.27,8.52,83.93-8.32,130.17-50.05,147.59-69.7,41.26,10.9,57.72,41.81,55.44,69.34-2.55,30.62-29.42,61.38-83.42,62.24-96.35-2.1-173.5-5.4-174.97-5.47l-18.46-.79-1.6,36.91,18.45.81c1.37.06,68.55,2.93,155.92,5.03v.63h18.48c1.15,0,2.2-.11,3.33-.13,88.27,1.9,192.26,2.79,269.64-.69,86.3-3.91,190.66-2.71,231.65,41.22,13.81,14.78,20.46,34.43,20.41,59.54-57.88-23.24-124.99-23.19-149.14-22.18-90.6,3.61-354.24.88-417.88.15-4.49-16.02-10.43-30.32-17.93-41.31l-10.41-15.26-30.53,20.83,10.42,15.27c25.35,37.13,28.96,132.72,6.55,173.35l-8.92,16.18,32.37,17.84,8.92-16.18c3.61-6.54,6.69-13.98,9.28-22.09,40.73-1.06,304.05-7.54,391.27.07,44.55,3.89,96.32,18.68,110.19,64.33.17,2.37.69,4.6,1.66,6.64,1.22,5.79,2.01,11.91,2.01,18.64,0,24.25-6.76,40.32-20.64,49.1ZM1361.52,1295.82c-10.05,9.89-34.04,9.12-64.43,8.23-5.46-.17-11.16-.32-16.97-.44-13.97-35.02-49.77-73.8-139.06-81.59-85.38-7.44-325.12-1.98-386.66-.44,2.99-23.88,2.87-49.85-.22-74.42,75.16.83,323.91,3.24,412.01-.27,59.81-2.4,137.98,8.53,177.83,46.34,17.77,16.88,26.56,37.49,26.87,63.04.25,19.88-2.92,33.19-9.37,39.54Z"/>
            <path class="cls-1" d="M343.1,1135.48l-16.28,8.66,17.3,32.6,16.31-8.62c1.4-.74,140.87-72.72,269.39,1.18l16.02,9.21,18.42-32.05-16.02-9.21c-146.6-84.21-298.71-5.2-305.13-1.78Z"/>
            <path class="cls-1" d="M350.52,810.19l38.76,38.76,140.88-140.88,645.11.53.16-194.6.27-322.96-128.4-.11,102.18-102.18-38.76-38.76-140.88,140.88-450.69-.37h0s-194.41-.16-194.41-.16l-.16,194.41-.27,323.15,128.4.11-102.18,102.18ZM1136.41,669.68l-111.71-.09c14.14-54.62,57.23-97.71,111.8-111.79l-.09,111.88ZM1136.77,229.91l-.09,111.7c-54.55-14.14-97.56-57.23-111.61-111.8l111.7.09ZM989.89,248.35c20.71,67.21,76.88,118.92,146.76,133.17l-.11,136.37c-76.24,15.42-136.24,75.43-151.75,151.67l-415.76-.34,92.69-92.69c25.02,17.41,55.36,27.69,88.15,27.72h.13c85.45,0,154.74-69.23,154.81-154.69.03-32.88-10.27-63.31-27.72-88.4l112.81-112.81ZM651.1,509.61c-10.75-17.6-17.06-38.19-17.04-60.28.05-63.87,52.06-115.83,115.92-115.83h.1c21.58.02,42.19,6.01,60.14,16.99l-159.12,159.12ZM848.97,389.27c10.98,17.99,16.96,38.64,16.94,60.26-.05,63.87-52.06,115.83-116.02,115.83-21.99-.02-42.49-6.3-60.01-16.99l159.1-159.1ZM363.59,229.27h.17l111.53.09c-14.14,54.5-57.2,97.5-111.79,111.58l.09-111.68ZM363.46,380.87c76.11-15.43,136.18-75.38,151.73-151.47l415.78.34-92.64,92.64c-25.03-17.44-55.4-27.74-88.22-27.77h-.13c-85.45,0-154.74,69.23-154.81,154.69-.03,32.91,10.29,63.37,27.78,88.47l-112.83,112.83c-20.72-67.32-76.95-119.07-146.76-133.34l.11-136.38ZM363.23,669.04l.09-111.88c54.56,14.17,97.58,57.32,111.62,111.98l-111.72-.09Z"/>
            <path class="cls-1" d="M484.22,517.29c37.57,0,68.05-30.44,68.08-68.02.03-37.6-30.42-68.1-68.02-68.14h-.06c-37.57,0-68.05,30.44-68.08,68.02-.03,37.6,30.42,68.1,68.02,68.14h.06ZM455.03,449.19c.01-16.08,13.11-29.16,29.19-29.16h.06c7.78.01,15.1,3.06,20.6,8.57,5.51,5.52,8.54,12.85,8.53,20.65-.01,16.08-13.11,29.16-29.21,29.16-7.8,0-15.12-3.05-20.63-8.57-5.51-5.52-8.54-12.85-8.53-20.65Z"/>
            <path class="cls-1" d="M1015.7,517.73h.06c37.57,0,68.05-30.44,68.08-68.02.03-37.6-30.42-68.1-68.02-68.14h-.06c-37.57,0-68.05,30.44-68.08,68.02-.03,37.6,30.42,68.11,68.02,68.14ZM1015.75,420.46h.06c7.78.01,15.1,3.06,20.6,8.57,5.51,5.52,8.54,12.85,8.53,20.65-.01,16.08-13.11,29.16-29.21,29.16-7.8,0-15.12-3.05-20.63-8.57-5.51-5.52-8.54-12.85-8.53-20.65.01-16.08,13.11-29.16,29.19-29.16Z"/>
          </svg>
          <svg v-else-if="taskGroup.serviceGroup === 'LOGIST' || taskGroup.serviceGroup === 'DIGIT'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1500 1500">
            <g>
              <path class="st0" d="M995.2,1023.4V756.6V232.3h-80.8v524.3h-91.9l-67.4-348.3c-7.1-36.6-39.3-63.2-76.6-63.2H282.1
                c-43,0-78,35-78,78v333.5h-49.9C96.6,756.6,50,803.2,50,860.7v224c0,20.7,13.7,38.1,32.5,43.8c6.7,77.8,72.1,139.1,151.6,139.1
                c75.6,0,138.5-55.4,150.2-127.8H643c11.7,72.4,74.6,127.8,150.2,127.8c49.4,0,93.4-23.7,121.2-60.3v2h1.9v1.9h366.4v-65.8H995.2
                V1023.4z M234.2,1205.7c-49.7,0-90.2-40.5-90.2-90.2s40.5-90.2,90.2-90.2s90.2,40.5,90.2,90.2S283.9,1205.7,234.2,1205.7z
                M579.5,910.7l-48.5-78.9H271.7V423.1c0-5.7,4.7-10.4,10.4-10.4h396.5c5,0,9.2,3.5,10.2,8.4L766,820.3v90.3H579.5z M793.2,1205.7
                c-49.7,0-90.2-40.5-90.2-90.2s40.5-90.2,90.2-90.2c49.7,0,90.2,40.5,90.2,90.2S843,1205.7,793.2,1205.7z M914.4,1023.6
                c0,0-0.1-0.1-0.1-0.1h0.1V1023.6z"/>
              <rect x="1061" y="711.5" class="st0" width="389" height="374"/>
            </g>
          </svg>
          <svg v-else-if="taskGroup.serviceGroup === 'MESSEIN'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1500 1500">
            <path class="cls-1" d="M1330,354.71c-120.3-165.76-324.18-263.53-580-263.53S290.3,188.94,170,354.7c-77.21,106.38-120,240.77-120,395.3s42.79,288.91,120,395.3c120.31,165.76,324.18,263.53,580,263.53s459.7-97.77,580-263.53c77.21-106.38,120-240.77,120-395.3s-42.79-288.91-120-395.29ZM749.23,352.7c52.08,0,94.3,42.22,94.3,94.3s-42.22,94.3-94.3,94.3-94.3-42.22-94.3-94.3,42.22-94.3,94.3-94.3ZM920.05,1147.3h-340.1v-125.22h81.93v-296.82h-81.93v-122.13h256.62v418.95h83.48v125.22Z"/>
          </svg>
          <svg v-else-if="taskGroup.serviceGroup === 'PACKE'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1500 1500">
            <g>
              <path class="st0" d="M506.1,394.7v65.4h520.6c2.6,7.1,6.1,13.7,10.4,19.6c16,22,43,35,76.9,35s61-13,76.9-35
                c4.3-5.9,7.8-12.5,10.4-19.6h139v-65.4h-139c-2.6-7.2-6.1-13.9-10.5-19.8c-16-22-43-35-76.9-35c-33.9,0-61,13-76.9,35
                c-4.3,6-7.8,12.6-10.5,19.8H506.1z"/>
              <path class="st0" d="M929.2,573.2c-2.6-7.2-6.1-13.9-10.5-19.8c-16-22-43-35-76.9-35c-33.9,0-61,13-76.9,35
                c-4.3,6-7.8,12.6-10.5,19.8H506.9v65.4h247.5c2.6,7.1,6.1,13.7,10.4,19.6c16,22,43,35,76.9,35c33.9,0,61-13,76.9-35
                c4.3-5.9,7.8-12.5,10.4-19.6h412.2v-65.4H929.2z"/>
              <path class="st0" d="M1104.4,731.9c-16-22-43-35-76.9-35c-33.9,0-61,13-76.9,35c-4.3,6-7.8,12.6-10.5,19.8H506.9v65.4h433.1
                c2.6,7.1,6.1,13.7,10.4,19.6c16,22,43,35,76.9,35c33.9,0,61-13,76.9-35c4.3-5.9,7.8-12.5,10.4-19.6h226.5v-65.4h-226.5
                C1112.2,744.5,1108.7,737.9,1104.4,731.9z"/>
              <path class="st0" d="M733.1,919.3c-16-22-43-35-76.9-35c-33.9,0-61,13-76.9,35c-2.5,3.4-4.7,7.1-6.7,11h-65.6v65.4h59.2
                c2.6,10.6,7.1,20.2,13.1,28.5c16,22,43,35,76.9,35c33.9,0,61-13,76.9-35c6-8.3,10.4-17.9,13.1-28.5h595.1v-65.4H739.8
                C737.9,926.4,735.6,922.8,733.1,919.3z"/>
              <path class="st0" d="M909.9,1199.5v-141.2h-53v138.1H293.6V201.1h563.3V339h53V198c0-27.5-22.4-49.9-49.9-49.9H290.5
                c-27.5,0-49.9,22.4-49.9,49.9v1001.5c0,27.5,22.4,49.9,49.9,49.9H860C887.5,1249.4,909.9,1227,909.9,1199.5z"/>
              <path class="st0" d="M939.1,1368.8c0,15.5-12.6,28.1-28.1,28.1H239.9c-15.5,0-28.1-12.6-28.1-28.1V131.2
                c0-15.5,12.6-28.1,28.1-28.1H911c15.5,0,28.1,12.6,28.1,28.1v208.7h53V131.2c0-44.8-36.4-81.2-81.2-81.2H239.9
                c-44.8,0-81.2,36.4-81.2,81.2v1237.7c0,44.8,36.4,81.2,81.2,81.2H911c44.8,0,81.2-36.4,81.2-81.2v-309.7h-53V1368.8z"/>
              <path class="st0" d="M430.9,1298c-14.6,0-26.5,11.9-26.5,26.5c0,14.6,11.9,26.5,26.5,26.5h284.6c14.6,0,26.5-11.9,26.5-26.5
                c0-14.6-11.9-26.5-26.5-26.5H430.9z"/>
            </g>
          </svg>
          <svg v-else-if="taskGroup.serviceGroup === 'CATERING'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1500 1500">
            <path class="cls-1" d="M1439.42,795.24c0-30.11-30.21-55.45-91.63-76.99v3.05c0,24.33-22.13,52.17-186.25,74.21-110.07,14.8-256.22,22.94-411.54,22.94-245.01,0-460.01-20.17-547.74-51.38-18.4-6.54-32.02-14.77-40.51-24.45-4.75-5.41-7.84-11.23-9.11-17.29l-.43-4.03v-3.07c-61.42,21.55-91.63,46.92-91.63,77.01,0,35.84,44.43,63.4,112.74,84.36-10.8,18.79-6.27,41.37-1.52,57.34,14.6,48.93,68.93,59.91,121.48,70.51,55.31,11.17,92.13,20.8,99.73,51.56,3.96,16.09-1.14,28.89-8.19,46.62-9.16,23.01-20.57,51.65-14.45,95.55,3.73,26.78,14.64,50.83,31.05,70.76-12.23,31.91-11.11,64.57,3.71,92.83,14.69,28.04,49.28,64.48,130.67,78.87,24.06,4.25,46.35,6.36,66.6,6.36,48.67,0,85.52-12.14,106.59-35.71,11.34-12.68,22.54-33.89,17.96-65.56,48.36-22.49,97.76-62.33,138.53-124.38,90.22-137.3,114.56-174.31,305.29-186.78,38.99-1.16,68.75,8.22,92.55,15.48,15.31,4.66,30.85,9.4,45.69,9.4,19.73,0,38.26-8.35,53.47-36.34,14.51-26.69,13.78-57.78-1.99-85.28-12.12-21.13-32.31-39.26-59.23-54.06,82.46-21.71,138.16-51.42,138.16-91.52ZM525.27,932.08c71.84,4.73,141.75,7,201.03,7.47-71.27,29-133.36,52.83-184.55,53.55-2.04.15-5.65.36-9.77.49,1.56-19.5.38-41.12-6.72-61.51ZM679.99,1388.37c-19.93,22.33-71.32,28.62-137.41,16.98-51.37-9.08-87.95-29.91-103.01-58.64-8.48-16.2-8.99-32.22-6.29-45.99,24.07,16.36,53.57,26.9,86.49,29.52l7.64.61c8.57,7.71,18.41,15.35,30,22.8,18.24,11.71,43.16,18.29,71.71,18.29,18.62,0,38.8-2.87,59.68-8.86-.13,9.99-2.84,18.58-8.83,25.28ZM1160.95,999.25c-195.29,13.69-230.01,54.66-327.98,203.73-92.62,140.97-217.89,141.51-254.53,117.95-48.37-31.08-68.6-69.22-58.5-110.33,14.26-58.04,85.89-108.92,163.07-115.83l19.37-1.73-3.46-38.74-19.37,1.73c-94.24,8.45-179.1,70.89-197.37,145.28-4.91,20.01-7.16,51.02,9.68,84.33-38.49-11.35-75.89-39.01-82.96-89.84-4.71-33.71,3.81-55.11,12.05-75.8,8.25-20.72,16.77-42.12,9.83-70.32-14.07-56.99-75.56-69.41-129.8-80.36-43.19-8.72-83.97-16.97-91.89-43.52-4.1-13.75-4.68-23.89-1.58-27.8,2.1-2.66,6.15-4.65,11.75-6.13,74.92,17.67,168.12,29.48,261.18,36.93.43.62.96,1.17,1.37,1.81,27.13,42.55.02,111.35-.59,112.85l-7.37,17.97,35.99,14.75,7.37-18c.48-1.16,4.38-10.97,8.14-25.61,9.38-.01,17.47-.59,18.15-.67,61.69-.84,133.07-30.02,215.72-63.78,24-9.81,48.75-19.91,74.03-29.63,17.86-.46,36.27-1.07,55.13-1.84-42.5,29.33-76.42,73.24-107.91,135.97l-8.72,17.38,34.76,17.44,8.72-17.38c54.32-108.19,110.75-163.15,268.55-163.25h.14c42.12,0,71.65,13.49,81.01,37.03,4.79,12.06,3.13,25.57-3.96,35.39ZM1326.77,960.18c9.16,15.98,9.69,32.36,1.53,47.36-11.07,20.37-16.28,19.67-53.64,8.29-18.56-5.66-42.18-12.84-71.63-15.82,4.87-16.2,4.56-34.06-1.98-50.52-3.65-9.18-11.95-24.39-29.55-37.4,22.25-3.24,43.92-6.77,64.56-10.71,62.29,19.57,84.25,47.54,90.7,58.78Z"/>
            <path class="cls-1" d="M750,207.5c54.76,0,90.14-30.91,90.14-78.75s-35.38-78.76-90.14-78.76-90.14,30.91-90.14,78.76,35.38,78.75,90.14,78.75Z"/>
            <path class="cls-1" d="M750,779.57c326.61,0,535.19-35.6,558.9-60.91v-12.47s0,0-.02,0v-40.17c0-262.84-171.66-450.11-438.03-493.21-17.56,44.82-62.36,73.58-120.86,73.58s-103.3-28.76-120.86-73.58c-266.36,43.1-438.03,230.37-438.03,493.21v40.16s0,0-.02,0v11.43c2.2,1.81,8.48,7.23,24.2,12.82,82.59,29.39,297.48,49.13,534.7,49.13ZM328.63,499c46.03-106.8,137.64-185.06,257.96-220.35l18.65-5.48,10.95,37.32-18.67,5.47c-109.01,31.98-191.83,102.45-233.2,198.43l-7.69,17.86-35.71-15.4,7.7-17.85ZM295.71,663.53c0-26.94,2.4-53.6,7.14-79.24l3.54-19.12,38.23,7.07-3.52,19.12c-4.31,23.32-6.5,47.61-6.5,72.18v19.44h-38.89v-19.44Z"/>
          </svg>
          <svg v-else-if="taskGroup.serviceGroup === 'AX-EINTR'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1500 1500">
            <path class="cls-1" d="M778.06,662.57l8.08,47.03-47.29,8.12-8.07-47.03,47.28-8.12ZM830.47,740.95l-21.07-122.73-122.96,21.12,21.06,122.72,122.97-21.11"/>
            <path class="cls-1" d="M442,768.75l-8.08-47.02,47.28-8.12,8.08,47.03-47.28,8.11ZM512.55,669.27l-122.96,21.11,21.07,122.7,122.96-21.11-21.07-122.71"/>
            <path class="cls-1" d="M789.83,1014.15l-8.08-47.02,47.28-8.13,8.08,47.04-47.28,8.11ZM860.37,914.66l-122.96,21.12,21.07,122.71,122.96-21.11-21.07-122.72"/>
            <path class="cls-1" d="M492.88,1065.88l-8.08-47.04,47.28-8.13,8.08,47.04-47.28,8.13ZM440.46,987.5l21.07,122.72,122.96-21.12-21.07-122.72-122.96,21.12"/>
            <polyline class="cls-1" points="639.5 647.41 559.33 661.21 565.83 699.04 608.15 691.76 623.52 781.13 581.22 788.4 587.72 826.25 667.86 812.48 639.5 647.41"/>
            <polyline class="cls-1" points="814.58 875.05 852.42 868.55 838.54 787.99 800.7 794.51 814.58 875.05"/>
            <polyline class="cls-1" points="683.13 897.38 767.72 882.85 753.94 802.54 716.09 809.04 723.38 851.5 668.5 860.94 638.79 866.04 638.79 866.04 596.09 873.39 602.58 911.23 645.3 903.89 653.3 950.41 610.58 957.76 617.1 995.59 697.63 981.72 683.13 897.38"/>
            <polyline class="cls-1" points="624.99 1042.49 631.49 1080.34 712.25 1066.48 705.76 1028.64 624.99 1042.49"/>
            <polyline class="cls-1" points="462.84 891.25 510.27 883.11 517.62 925.83 555.45 919.34 541.61 838.74 418.5 859.91 432.35 940.49 470.19 934 462.84 891.25"/>
            <path class="cls-1" d="M1164.95,548.07l-107.72-24.65,8.57-37.43,107.72,24.66-8.57,37.42ZM896.29,1298.65c-11.35-41.46-36.43-77.44-71.94-102.65-40.71-28.92-90.12-40.24-139.44-31.92-95.2,16.12-161.48,101.99-155.27,196.65l-142.1,24.04-143.81-849.35,45.43-7.69-6.42-37.86-45.42,7.69-49.62-293.09,142.08-24.06c25.19,91.11,115.9,150.42,211.32,134.31,95.21-16.13,161.51-102.03,155.3-196.39l142.11-24.06,49.63,293.1-45.44,7.69,6.42,37.87,45.43-7.7,143.8,849.37-142.06,24.06ZM950.57,459.63l82.34,18.83-8.57,37.42-78.55-17.96-1.7-10.01,6.47-28.28ZM1281.69,535.4l74.88-327.21-214.37-49.07-4.29,18.73c-18.27,79.82-98.05,129.88-177.89,111.63-17.88-4.1-34.6-11.31-49.67-21.44l-3.92-2.63-36.48-215.41-216.85,36.7,3.21,18.93c13.67,80.74-40.89,157.55-121.62,171.22-80.65,13.66-157.54-40.89-171.22-121.63l-3.21-18.92-216.83,36.7,56.03,330.96h0l3.88,22.88,152.77,902.2,197.91-33.5,18.89-3.47-1.82-10.7c-1.56-7.13-2.53-14.46-3.04-21.93-.08-1.07-.1-2.13-.16-3.2-.11-2.33-.35-4.63-.35-6.98,0-.96.13-1.89.15-2.85.03-3.1.24-6.17.46-9.25.12-1.43.18-2.88.34-4.31,2.6-25.14,11.53-49.33,26.56-70.5,21.86-30.76,53.94-51.51,90.69-59.18.57-.13,1.13-.26,1.7-.38,1.31-.26,2.57-.63,3.89-.86,2.66-.45,5.33-.65,8-.95,1.15-.14,2.29-.31,3.44-.41,3.63-.33,7.25-.48,10.86-.55,1.11-.02,2.19-.16,3.31-.16.46,0,.89.06,1.34.07,2.84.04,5.66.23,8.48.43,2.47.16,4.94.29,7.39.57,1.19.15,2.38.37,3.56.55,72.65,10.14,128.63,72.36,128.63,147.8,0,15.59-2.4,30.62-6.83,44.75l-1.63,6.91,214.5,49.09,200.74-877.17-75.29-17.24,8.56-37.43,75.29,17.24"/>
            <polyline class="cls-1" points="501.1 452.9 507.52 490.76 630.77 469.87 624.35 432.01 501.1 452.9"/>
            <polyline class="cls-1" points="330.29 481.81 336.71 519.66 459.97 498.81 453.55 460.95 330.29 481.81"/>
            <polyline class="cls-1" points="671.89 423.97 678.31 461.82 801.57 440.96 795.16 403.11 671.89 423.97"/>
          </svg>
          <svg v-else-if="taskGroup.serviceGroup === 'AUFANR'" id="Ebene_2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2000 2000" class="aufanr">
            <g>
              <g>
                <path class="cls-3" d="M1458.65,1136.68h-927.85c-144.2,0-139.78,111.87-139.78,111.87v482.96c0,24.77,20.08,44.85,44.85,44.85h148.39c24.77,0,44.85-20.08,44.85-44.85v-51.78c0-36.93,29.94-66.88,66.88-66.88h298.74s298.73,0,298.73,0c36.94,0,66.89,29.95,66.89,66.89v51.77c0,24.77,20.08,44.85,44.85,44.85h148.39c24.77,0,44.85-20.08,44.85-44.85v-482.96s4.42-111.87-139.78-111.87Z"></path>
                <circle class="cls-1" cx="576.55" cy="1310.4" r="84.25"></circle>
                <circle class="cls-1" cx="1384.64" cy="1310.4" r="84.25"></circle>
                <line class="cls-1" x1="856.36" y1="1508.67" x2="1133.09" y2="1508.67"></line>
                <path class="cls-1" d="M996.96,735.09h-250.24c-174.98,0-183.59,109-183.59,109l-32.33,292.59h932.31s-32.33-292.59-32.33-292.59c0,0-8.61-109-183.59-109-209.4,0-250.24,0-250.24,0"></path>
                <path class="cls-4" d="M1469.2,1135.81s55.43-120.87,144.9-55.54"></path>
                <path class="cls-4" d="M530.8,1135.81s-55.43-120.87-144.9-55.54"></path>
              </g>
              <path class="cls-6" d="M1278.16,900.42c0,40.85-29.88,73.96-82.53,73.96s-82.53-33.11-82.53-73.96,29.89-73.96,82.53-73.96,82.53,33.11,82.53,73.96Z"></path>
              <path class="cls-6" d="M1374.15,1101.37c0-54.75-37.13-95.37-94.6-103.48-24.41-3.46-48.91-3.4-72.63-3.29l-11.36.02-11.13-.03c-23.74-.09-48.32-.19-72.72,3.36-57.15,8.32-94.08,48.91-94.08,103.42v50.69h62.68v-73.59h19.89v73.59h192.03v-73.59h19.89v73.59h62.03v-50.69Z"></path>
            </g>
            <polyline class="cls-5" points="1950 828.96 1000 223.64 50 828.96"></polyline>
            <polyline class="cls-2" points="385.9 606.77 385.9 223.64 564.97 223.64 564.97 500.03"></polyline>
          </svg>
          <svg v-else version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
              viewBox="0 -2 36 36" style="enable-background:new 0 0 32 32;" xml:space="preserve">
              <path class="st0" d="M158.03,61.5"/>
              <g>
                <path class="st1" d="M31.03,16.25c0-8.56-2.31-12.72-4.36-12.81c-3.27-0.14-3.43,7.25-6.54,7.08c-3.11-0.18-0.82-7.33-5.07-7.33
                  c-3.92,0-2.62,11.58-5.4,11.93C6.89,15.48,8.2,0.26,4.6,0.61c-3.02,0.3-3.58,10.71-3.62,15.14H0.97c0,4.08,0.49,15.33,3.63,15.64
                  c3.6,0.35,2.29-14.86,5.07-14.51c2.78,0.35,1.47,11.93,5.4,11.93c4.25,0,1.96-7.15,5.07-7.33c3.11-0.18,3.27,7.22,6.54,7.08
                  C28.68,28.47,30.93,24.47,31.03,16.25L31.03,16.25z"/>
                <path class="st0" d="M31.03,16.25c0-8.56-2.31-12.72-4.36-12.81c-3.27-0.14-3.43,7.25-6.54,7.08c-3.11-0.18-0.82-7.33-5.07-7.33
                  c-3.92,0-2.62,11.58-5.4,11.93C6.89,15.48,8.2,0.26,4.6,0.61c-3.02,0.3-3.58,10.71-3.62,15.14H0.97c0,4.08,0.49,15.33,3.63,15.64
                  c3.6,0.35,2.29-14.86,5.07-14.51c2.78,0.35,1.47,11.93,5.4,11.93c4.25,0,1.96-7.15,5.07-7.33c3.11-0.18,3.27,7.22,6.54,7.08
                  C28.68,28.47,30.93,24.47,31.03,16.25L31.03,16.25z"/>
              </g>
            </svg>
        </div>
        <div class="items__content content--name">
          {{ taskGroup.title }}
        </div>
      </div>
      <div
        class="task__items task__items2"
      >
      <div class="items__content content--date" v-if="hasDate && !done">
          {{ $d(this.date, 'L') }}
        </div>
        <div class="items__content content--date" v-if="done">
          <font-awesome-icon icon="check" />
        </div>
      </div>
    </div>
    <b-collapse class="section-tab" :id="taskGroup._id">
      <ul class="tasklisting__list">
        <li class="list__item" v-for="task in taskGroup.tasks.sort(tasksorting)" :key="task._id">
          <task-item
            ref="subitem"
            :task="task"
            :booth="booth"
            :renderCondition="renderCondition"
            :link="taskLinks.find(item => item.typ === task.serviceGroup)"
            :linkParams="linkParams"
            :service-shop-id="serviceShopId"
            :startLoadingShopLinks="startLoadingShopLinks"
            :isCoexposant="isCoexposant"
            :shopLinks="shopLinks"
            @updateGroup="updateGroup"
          />
        </li>
      </ul>
    </b-collapse>
  </div>
</template>
<script>
import Vue from 'vue'
import TaskItem from '@/components/TaskItem'
import { VBToggle, BCollapse } from 'bootstrap-vue'
import ApiService from '@/services/ApiService'

Vue.directive('b-toggle', VBToggle)

export default {
  name: 'TaskItemGroup',
  components: { TaskItem, BCollapse },
  props: {
    sorting: {
      type: String,
      required: false
    },
    taskGroup: {
      type: Object,
      required: true,
      default: () => ({})
    },
    shopLinks: {
      type: Array,
      required: true,
      default: () => []
    },
    renderCondition: {
      type: String,
      default: ''
    },
    isCoexposant: Boolean,
    booth: String,
    serviceShopId: String,
    taskLinks: {
      type: Array,
      default: () => []
    },
    insurance: {
      type: Object,
      default: () => ({})
    },
    filters: {
      type: Object,
      default: () => ({})
    },
    taskLinksAttributes: {},
    startLoadingShopLinks: {
      type: Boolean,
      default: true
    },
    linkParams: {}
  },
  data() {
    return {
      isOpen: false,
      //      taskGroupItem: this.taskGroup,
      deeplink: undefined,
      state: {
        type: 'unknown',
        val: 100
      },
      hasDate: false,
      date: null,
      done: false,
      renderGroup: false,
      boothInfo: {}
    }
  },
  methods: {
    tasksorting(a, b) {
      if (this.sorting === 'done') {
        return this.spaceship(
          a.isDone == true, 
          b.isDone == true);
      }
      if (this.sorting === 'notdone') {
        return this.spaceship(
          a.isDone == false, 
          b.isDone == false);
      }
      if (this.sorting === 'ascending') {
        return this.spaceship(a.displayName, b.displayName);
      }
      if (this.sorting === 'descending') {
        return this.spaceship(b.displayName, a.displayName);
      }
      return 0
    },
    spaceship(val1, val2) {
      if ((val1 === null || val2 === null) || (typeof val1 != typeof val2)) {
        return null;
      }
      if (typeof val1 === 'string') {
        return (val1).localeCompare(val2);
      } else {
        if (val1 > val2) {
          return 1;
        } else if (val1 < val2) {
          return -1;
        }
        return 0;
      }
    },
    stopPropagation(e) {
      e.stopPropagation()
    },
    getUrl() {
      if (this.hasKatalogLink) {
        return this.getKatalogLink
      }
      if (this.hasFileuploadLink) {
        return this.getFileuploadLink
      }
      return this.taskGroup.url;
    },
    triggerDeeplink() {
      if ((this.hasExternalLink || this.hasKatalogLink || this.hasFileuploadLink) && !this.isInsurance) {
        this.setStepHistory(this.getUrl(), this.taskGroup.manualdeeplinktargetblank ? true : false)
      } else if (
        this.deeplink !== undefined &&
        !this.isInsurance &&
        this.taskGroup.deeplinkmode !== 'manual'
      ) {
        this.setStepHistory(this.deeplink.href)
      } else if (this.isInsurance) {
        this.setStepHistory(null)
      }
    },
    goToInsurance() {
      this.$router.push({
        name: 'Insurance'
      })
    },
    setStepHistory(url, newwindow) {
      const loc = this.$store.getters['ui/getLooseLocale'];

      const boothInfo = this.$store.getters['fair/getBooth'](
        this.$route.params.booth
      );

      ApiService.setCurrentStep(
        this.booth,
        this.taskGroup.serviceGroup,
        boothInfo.standnummer,
        boothInfo[`halleBezeichnung${loc.substring(0, 1).toUpperCase()}${loc.substring(1, 2).toLowerCase()}`],
        this.$route.params.code
      )

      if (url === null) {
        this.goToInsurance()
        return
      }

      const fullUrl =
        url +
        '?' +
        this.parsedParams(
          Object.assign(this.linkParams, {
            language: this.$store.getters['ui/getLooseLocale'],
            'regi-nr': this.booth,
            'service-group': this.taskGroup.serviceGroup
          })
        )


      if (newwindow === true) {
        window.open(fullUrl, '_blank')
      } else {
        window.location.href = fullUrl
      }
    },
    parsedParams(data) {
      let retVal = []
      for (let key in data) {
        retVal.push(encodeURI(key) + '=' + encodeURI(data[key]))
      }
      return retVal.join('&')
    },
    checkServiceShopLinks() {
      if (
        this.startLoadingShopLinks &&
        this.taskGroup.serviceGroup !== undefined &&
        this.taskGroup.serviceGroup.length > 0 &&
        this.taskGroup.serviceGroup.toLowerCase() !== 'vers' &&
        (this.taskGroup.deeplinkmode !== 'manual' || this.taskGroup.url !== undefined) &&
        this.link === undefined &&
        this.serviceShopId !== null
      ) {
        const promise = new Promise((resolve, reject) => {
          const lang = this.$store.getters['ui/getLocale']
          ApiService.getRubinServiceShopLink(
            this.$route.params.booth,
            this.serviceShopId,
            this.taskGroup.serviceGroup,
            lang.toLowerCase().substr(0, 2)
          ).then(
            result => {
              this.deeplink = result.data[0]
              this.$emit('updateGroup')
              resolve()
            },
            err => {
              console.log(err)
              resolve()
            }
          )
        })
      }
    },
    updateGroup() {
      this.hasDate = false
      this.date = null
      this.renderGroup = true
      let tmpDone = true

      let renderCount = 0
      let tmpState = 10000

      for (let key in this.$refs.subitem) {
        if (this.$refs.subitem[key].renderTask) {
          renderCount++
        } else {
          continue;
        }
        if (this.$refs.subitem[key].state.val < tmpState) {
          tmpState = this.$refs.subitem[key].state.val
          this.state = this.$refs.subitem[key].state
        }
        if (this.taskGroup.serviceGroup === 'VERS') {
          // console.log(this.state)
        }
        if (
          !this.$refs.subitem[key].isDone &&
          this.$refs.subitem[key].state.type !== 'done'
        ) {
          tmpDone = false
        }
        if (
          this.$refs.subitem[key].hasDate &&
          this.$refs.subitem[key].state.type !== 'done'
        ) {
          this.hasDate = true

          let tmpDate = new Date(
            this.$refs.subitem[key].taskItem.period.end ||
              this.$refs.subitem[key].taskItem.period.start
          )

          if (this.date === null || tmpDate < this.date) {
            this.date = tmpDate
          }
        }
      }
      //console.log(this.taskGroup.title);
      //console.log(renderCount);
      if (renderCount === 0) {
        this.renderGroup = false
      }
      this.done = tmpDone
      this.$emit('updateVisible', this.taskGroup,this.renderGroup)
    }
  },
  computed: {
    hasNotification() {
      return false
    },
    hasExternalLink() {
      return this.taskGroup.deeplinkmode === 'manual' && this.taskGroup.url !== undefined
    },
    hasKatalogLink() {
      return this.taskGroup.deeplinkmode === 'katalog' && this.getKatalogLink !== null;
    },
    hasFileuploadLink() {
      return this.taskGroup.deeplinkmode === 'fileupload' && this.getFileuploadLink !== null;
    },
    getKatalogLink() {
      let links = this.shopLinks.map((item) => item.shopLinks.filter((item2) => item2.ziel === 'KATALOG') ).filter((item) => item.length > 0).reverse();
      if (links.length > 0) {
        return links[0][0].href;
      }
      return null
    },
    getFileuploadLink() {
      let links = this.shopLinks.map((item) => item.shopLinks.filter((item2) => item2.ziel === 'FILEUPLOAD') ).filter((item) => item.length > 0).reverse();
      if (links.length > 0) {
        return links[0][0].href;
      }
      return null
    },
    isInsurance() {
      return (
        this.taskGroup.serviceGroup !== undefined &&
        this.taskGroup.serviceGroup.toLowerCase() === 'vers'
      )
    }
  },
  watch: {
    '$props.startLoadingShopLinks'() {
      this.checkServiceShopLinks()
    },
    'this.$route.params.booth'(newBooth) {
      this.checkServiceShopLinks()
    },
    '$props.serviceShopId'(newServiceShopId) {
      this.checkServiceShopLinks()
    }
  },
  mounted() {
    this.boothInfo = this.$store.getters['fair/getBooth'](
      this.$route.params.booth
    );
    this.checkServiceShopLinks()
  }
}
</script>
<style lang="scss">
@import '@/assets/css/variables.scss';

$taskgroupitem-task-padding-y: 0.625rem !default;
$taskgroupitem-task-padding-x: 1.5em !default;

$taskgroupitem-task-title-margin: 0 !default;
$taskgroupitem-task-title-font-size: null !default;
$taskgroupitem-task-title-font-weight: null !default;
$taskgroupitem-task-title-color: null !default;

$taskgroupitem-task-attention-size: 1.6em !default;
$taskgroupitem-task-attention-bg: $brand-white !default;
$taskgroupitem-task-attention-color: $brand-red !default;
$taskgroupitem-task-attention-box-shadow: 0 0 4px 0 rgba($brand-black, 0.33) !default;

$taskgroupitem-task-content-gap: $grid-gutter * 2 !default;

$taskgroupitem-task-content-icon-min-width: 7em !default;

$taskgroupitem-task-content-date-min-width: $taskgroupitem-task-content-icon-min-width !default;
$taskgroupitem-task-content-date-font-size: inherit !default;
$taskgroupitem-task-content-date-font-weight: inherit !default;

$taskgroupitem-task-content-name-font-size: inherit !default;
$taskgroupitem-task-content-name-font-weight: $font-weight-bold !default;

$taskgroupitem-task-content-notification-font-size: $taskgroupitem-task-content-date-font-size !default;
$taskgroupitem-task-content-notification-font-weight: $taskgroupitem-task-content-date-font-weight !default;

$taskgroupitem-task-content-link-font-size: 1.1em !default;
$taskgroupitem-task-content-link-font-weight: $taskgroupitem-task-content-date-font-weight !default;

$taskgroupitem-infotext-padding: 1em $taskgroupitem-task-padding-x !default;
$taskgroupitem-infotext-bg: lighten($brand-lightgray, 2%) !default;
$taskgroupitem-infotext-font-size: 0.9em !default;
$taskgroupitem-infotext-font-weight: inherit !default;
$taskgroupitem-infotext-color: inherit !default;
$taskgroupitem-infotext-box-shadow: inset 0 0 4px 0 rgba($brand-black, 0.05) !default;
$taskgroupitem-infotext-info-gap: 0.5em !default;

$taskgroupitem-task-state-unknown-bg: $brand-primary !default; // brand-gray
$taskgroupitem-task-state-unknown-color: $brand-white !default;

$taskgroupitem-task-state-insurance-bg: $brand-primary !default; // $brand-blue
$taskgroupitem-task-state-insurance-color: $brand-white !default;

$taskgroupitem-task-state-inactive-bg: $brand-primary !default; // $brand-olive
$taskgroupitem-task-state-inactive-color: $brand-white !default;

$taskgroupitem-task-state-pendent-bg: $brand-primary !default; // $brand-blue
$taskgroupitem-task-state-pendent-color: $brand-white !default;

$taskgroupitem-task-state-due-bg: $brand-primary !default; // $taskgroupitem-task-state-pendent-bg
$taskgroupitem-task-state-due-color: $brand-white !default;

$taskgroupitem-task-state-overdue-bg: $brand-primary !default; // $brand-red
$taskgroupitem-task-state-overdue-color: $brand-white !default;

$taskgroupitem-task-state-done-bg: $brand-primary !default; // $brand-turquoise
$taskgroupitem-task-state-done-color: $brand-white !default;

$taskgroupitem-task-state-title-bg: $brand-primary !default; // transparent
$taskgroupitem-task-state-title-color: $brand-darkgray !default;
$taskgroupitem-task-state-title-text-align: left !default;

$taskgroupitem-accordion-section-toggler-padding: 0.6em 10px !default;
$taskgroupitem-accordion-section-toggler-font-family: inherit !default;
$taskgroupitem-accordion-section-toggler-font-size: inherit !default;
$taskgroupitem-accordion-section-toggler-font-weight: $font-weight-bold !default;
$taskgroupitem-accordion-section-toggler-color: inherit !default;
$taskgroupitem-accordion-section-toggler-icon-gap: 0.5em !default;
$taskgroupitem-accordion-section-toggler-icon-width: 1.7em !default;
$taskgroupitem-accordion-section-toggler-icon-height: 1em !default;
$taskgroupitem-accordion-section-toggler-icon-color: $brand-blue !default;

$taskgroupitem-accordion-section-open-toggler-font-family: $taskgroupitem-accordion-section-toggler-font-family !default;
$taskgroupitem-accordion-section-open-toggler-font-size: $taskgroupitem-accordion-section-toggler-font-size !default;
$taskgroupitem-accordion-section-open-toggler-font-weight: $taskgroupitem-accordion-section-toggler-font-weight !default;
$taskgroupitem-accordion-section-open-toggler-color: $brand-blue !default;
$taskgroupitem-accordion-section-open-toggler-icon-gap: 0.5em !default;
$taskgroupitem-accordion-section-open-toggler-icon-width: 1.7em !default;
$taskgroupitem-accordion-section-open-toggler-icon-height: 1em !default;
$taskgroupitem-accordion-section-open-toggler-icon-color: $brand-blue !default;

$taskgroupitem-accordion-section-tab-padding: 0 0 4.5rem 1.5em !default;
$taskgroupitem-accordion-section-tab-transition: all 200ms ease-out !default;

$taskgroupitem-table-border: 1px solid lighten($brand-gray, 25%) !default;

.o-taskgroupitem {
  position: relative;

  .taskgroupitem__task {
    border-radius: 20px;
    display: flex;
    justify-content: space-between;
    position: relative;
    padding: $taskgroupitem-task-padding-y $taskgroupitem-task-padding-x;
    line-height: 1;

    .task__title {
      margin: $taskgroupitem-task-title-margin;
      font-size: $taskgroupitem-task-title-font-size;
      font-weight: $taskgroupitem-task-title-font-weight;
      color: $taskgroupitem-task-title-color;
    }

    .task__attention {
      display: none;
      position: absolute;
      bottom: 100%;
      left: 1.7em;
      width: $taskgroupitem-task-attention-size;
      height: $taskgroupitem-task-attention-size;
      background-color: $taskgroupitem-task-attention-bg;
      color: $taskgroupitem-task-attention-color;
      border-radius: 50%;
      box-shadow: $taskgroupitem-task-attention-box-shadow;
      transform: translateY(50%);

      .attention__icon {
        display: block;
        margin: -1px;
        width: calc(100% + 2px);
        height: calc(100% + 2px);
        font-size: $taskgroupitem-task-attention-size;
      }
    }

    .task__items {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-left: $taskgroupitem-task-content-gap * -0.5;
      margin-right: $taskgroupitem-task-content-gap * -0.5;

      .items__content {
        padding-left: $taskgroupitem-task-content-gap * 0.5;
        padding-right: $taskgroupitem-task-content-gap * 0.5;

        &.content--icon {
          padding-right: 0;
          min-width: 2em;
          color: inherit;
        }

        &.content--icon2 {
          width: 2rem;

          svg {
            height: 1.5rem;
            transform: scale(1.4)
          }
        }

        &.content--date {
          min-width: 6.2em;
          font-size: $taskgroupitem-task-content-date-font-size;
          text-align: right;
          font-weight: $taskgroupitem-task-content-date-font-weight;
        }

        &.content--name {
          font-size: $taskgroupitem-task-content-name-font-size;
          font-weight: $taskgroupitem-task-content-name-font-weight;
        }

        &.content--notification {
          font-size: $taskgroupitem-task-content-notification-font-size;
          font-weight: $taskgroupitem-task-content-notification-font-weight;
        }

        &.content--link {
          font-size: $taskgroupitem-task-content-link-font-size;
          font-weight: $taskgroupitem-task-content-link-font-weight;

          a {
            color: inherit;
            text-decoration: none;
          }
        }
      }
    }
  }

  .taskgroupitem__infotext {
    padding: $taskgroupitem-infotext-padding;
    background-color: $taskgroupitem-infotext-bg;
    font-size: $taskgroupitem-infotext-font-size;
    font-weight: $taskgroupitem-infotext-font-weight;
    color: $taskgroupitem-infotext-color;
    box-shadow: $taskgroupitem-infotext-box-shadow;

    p {
      margin: $taskgroupitem-infotext-info-gap 0 0;

      &:first-child {
        margin: 0;
      }
    }
  }

  &.state-unknown {
    .taskgroupitem__task {
      background-color: $taskgroupitem-task-state-unknown-bg;
      color: $taskgroupitem-task-state-unknown-color;
      .content--icon2 {
        svg {
          fill: $taskgroupitem-task-state-unknown-color;
        }
      }
    }
  }

  &.state-insurance,
  &.state-insurancedone {
    .taskgroupitem__task {
      background-color: $taskgroupitem-task-state-insurance-bg;
      color: $taskgroupitem-task-state-insurance-color;
      .content--icon2 {
        svg {
          fill: $taskgroupitem-task-state-insurance-color;
        }
      }
    }
  }

  &.state-inactive {
    .taskgroupitem__task {
      background-color: $taskgroupitem-task-state-inactive-bg;
      color: $taskgroupitem-task-state-inactive-color;
      .content--icon2 {
        svg {
          fill: $taskgroupitem-task-state-inactive-color;
        }
      }
    }
  }

  &.state-pendent {
    .taskgroupitem__task {
      background-color: $taskgroupitem-task-state-pendent-bg;
      color: $taskgroupitem-task-state-pendent-color;
      .content--icon2 {
        svg {
          fill: $taskgroupitem-task-state-pendent-color;
        }
      }
    }
  }

  &.state-due {
    .taskgroupitem__task {
      background-color: $taskgroupitem-task-state-due-bg;
      color: $taskgroupitem-task-state-due-color;
      .content--icon2 {
        svg {
          fill: $taskgroupitem-task-state-due-color;
        }
      }

      .task__attention {
        display: none; // block;
      }
    }
  }

  &.state-overdue {
    .taskgroupitem__task {
      background-color: $taskgroupitem-task-state-overdue-bg;
      color: $taskgroupitem-task-state-overdue-color;
      .content--icon2 {
        svg {
          fill: $taskgroupitem-task-state-overdue-color;
        }
      }
    }
  }

  &.state-done,
  &.state-insurancedone {
    .taskgroupitem__task {
      background-color: $taskgroupitem-task-state-done-bg;
      color: $taskgroupitem-task-state-done-color;
      .content--icon2 {
        svg {
          fill: $taskgroupitem-task-state-done-color;
        }
      }
    }
  }

  &.state-title {
    .taskgroupitem__task {
      display: block;
      overflow: hidden;
      padding-left: 0;
      padding-right: 0;
      padding-bottom: 0;
      background-color: $taskgroupitem-task-state-title-bg;
      color: $taskgroupitem-task-state-title-color;
      text-align: $taskgroupitem-task-state-title-text-align;
      line-height: 1.5;
    }
  }

  .centered {
    text-align: center;
  }

  @media screen {
    .md &,
    .sm &,
    .xs & {
      .taskgroupitem__task {
        display: block;

        .task__items {
          + .task__items {
            margin-top: $taskgroupitem-task-content-gap;
          }
        }
      }
    }

    .sm &,
    .xs & {
      .taskgroupitem__task {
        & > .task__items {
          display: flex;
        }
        .task__items2 {
          display: flex;
        }
      }
    }
  }

  .section-toggler {
    display: block;
    padding: $taskgroupitem-accordion-section-toggler-padding;
    width: 2rem;
    background: none;
    border: 0 none;
    font-family: $taskgroupitem-accordion-section-toggler-font-family;
    font-size: $taskgroupitem-accordion-section-toggler-font-size;
    font-weight: $taskgroupitem-accordion-section-toggler-font-weight;
    color: white;
    text-align: left;
    line-height: 19px;

    div.img {
      margin-right: $taskgroupitem-accordion-section-toggler-icon-gap;
      width: $taskgroupitem-accordion-section-toggler-icon-width;
      height: $taskgroupitem-accordion-section-toggler-icon-height;
      color: white;
      background-image: url("~@/assets/images/icons/chevron_bold_right_white_new.svg");
      background-size: 100%;
      background-position: 0;

      &.toggler-icon__expand {
        background-image: url("~@/assets/images/icons/chevron_bold_down_white_new.svg");
      }
    }

    &:hover {
      div.img {
        background-image: url("~@/assets/images/icons/chevron_bold_down_white_new.svg");
        &.toggler-icon__expand {
          background-image: url("~@/assets/images/icons/chevron_bold_right_white_new.svg");
        }
      }
    }

    &:hover {
      //        background-color: #f7f6f3;
    }

    &[aria-expanded='false'] {
      div.img {
        &.toggler-icon__expand {
          display: none;
        }
      }
    }

    &[aria-expanded='true'] {
      font-family: $taskgroupitem-accordion-section-open-toggler-font-family;
      font-size: $taskgroupitem-accordion-section-open-toggler-font-size;
      font-weight: $taskgroupitem-accordion-section-open-toggler-font-weight;
      color: $taskgroupitem-accordion-section-open-toggler-color;

      div.img {
        margin-right: $taskgroupitem-accordion-section-open-toggler-icon-gap;
        width: $taskgroupitem-accordion-section-open-toggler-icon-width;
        height: $taskgroupitem-accordion-section-open-toggler-icon-height;
        color: white;

        &.toggler-icon__collapse {
          display: none;
        }
      }
    }
  }

  .section-tab {
    overflow: hidden;
    transition: $taskgroupitem-accordion-section-tab-transition;

    table {
      th,
      td {
        width: 100%;
        border-top: $taskgroupitem-table-border;
        border-bottom: $taskgroupitem-table-border;
        text-align: left;

        &.col-article,
        &.col-amount,
        &.col-cost,
        &.col-total {
          width: 0%;
          white-space: nowrap;
        }

        &.col-amount,
        &.col-cost,
        &.col-total,
        &.col-totaltext,
        &.col-currency,
        &.col-summary {
          text-align: right;
        }
      }
    }
  }

  @media print {
    .taskgroupitem__task {
      .o-switcher {
        .switcher-wrapper {
          border-color: #000;

          .switcher-handle {
            border: 4px solid #000;
          }
        }
      }
    }

    &.state-unknown {
      .taskgroupitem__task {
        border: 2px solid $taskgroupitem-task-state-unknown-bg;
      }
    }

    &.state-insurance {
      .taskgroupitem__task {
        border: 2px solid $taskgroupitem-task-state-insurance-bg;
      }
    }

    &.state-inactive {
      .taskgroupitem__task {
        border: 2px solid $taskgroupitem-task-state-inactive-bg;
      }
    }

    &.state-pendent {
      .taskgroupitem__task {
        border: 2px solid $taskgroupitem-task-state-pendent-bg;
      }
    }

    &.state-due {
      .taskgroupitem__task {
        border: 2px solid $taskgroupitem-task-state-due-bg;
      }
    }

    &.state-overdue {
      .taskgroupitem__task {
        border: 2px solid $taskgroupitem-task-state-overdue-bg;
      }
    }

    &.state-done {
      .taskgroupitem__task {
        border: 2px solid $taskgroupitem-task-state-done-bg;
      }
    }
  }

  .task_toggle {
    color: white;
  }

  &.group-hidden {
    display: none;
  }

  .group-clickable {
    cursor: pointer;
  }

  .taskgroupitem__task {
    transition: all .2s ease-in-out;

    &:hover {
      transform: scale(1.1);  
    }
  }
}
</style>
  <style>
    .aufanr .cls-1, .aufanr .cls-2 {
      stroke-miterlimit: 10;
    }

    .aufanr .cls-1, .aufanr .cls-2, .aufanr .cls-3, .aufanr .cls-4, .aufanr .cls-5 {
      fill: none;
      stroke: currentcolor;
    }

    .aufanr .cls-1, .aufanr .cls-3 {
      stroke-width: 44.58px;
    }

    .aufanr .cls-2, .aufanr .cls-5 {
      stroke-width: 44.57px;
    }

    .aufanr .cls-3, .aufanr .cls-4 {
      stroke-linecap: round;
    }

    .aufanr .cls-3, .aufanr .cls-4, .aufanr .cls-5 {
      stroke-linejoin: round;
    }

    .aufanr .cls-4 {
      stroke-width: 44.19px;
    }

    .aufanr .cls-6 {
      fill: currentcolor;
    }
  </style>
